import Component from '@glimmer/component';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<button type=\'button\' class={{this.qlClass}} ...attributes>{{yield}}</button>");

/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component - single Quill toolbar button; derives its `ql-<type>` class from @type
 *   extends:   Component
 *   template:  button.hbs
 *   args:      @type
 *   uses:      -
 *   siblings:  select.js/.hbs, group.hbs, button-or-select.hbs (other quill/toolbar components)
 *   tests:     button-test.js (integration, tests/integration/components/quill/toolbar/),
 *              button-test.js (unit, tests/unit/components/quill/toolbar/)
 *
 * Renders a <button> whose class is `ql-<@type>` (Quill's own CSS hook for toolbar controls);
 * content is yielded (icon/label supplied by the caller).
 */
class QuillToolbarButtonComponent extends Component {
  get qlClass() {
    if (this.args.type) {
      return `ql-${this.args.type}`;
    }
    return null;
  }
}
setComponentTemplate(TEMPLATE, QuillToolbarButtonComponent);

export { QuillToolbarButtonComponent as default };
//# sourceMappingURL=button.js.map
